import { request } from '@/utils/request'
import { colors } from '@/components/charts/DonutChart.vue'
import { distinctBy, toDictionary } from '@/utils/array'

export const display = {
    salary: {
        label: 'Salary',
        color: colors[0],
    },
    bonus: { label: 'Bonus', color: colors[1] },
    stocks: { label: 'Equity', color: colors[2] },
    options: { label: 'Options', color: colors[3] },
    nonEquityIncentiveCompensation: { label: 'Non-Equity', color: colors[4] },
    other: { label: 'Other', color: colors[5] },
    total: { label: 'Total', color: colors[6] },
}

export function arrayify(compensationData) {
    const array = [
        { ...display.salary, value: compensationData.salary },
        { ...display.bonus, value: compensationData.bonus },
        { ...display.stocks, value: compensationData.stocks },
        { ...display.options, value: compensationData.options },
        { ...display.nonEquityIncentiveCompensation, value: compensationData.nonEquityIncentiveCompensation },
        { ...display.other, value: compensationData.other },
    ]

    array.forEach(datum => {
        datum.percentage = compensationData.total == 0 ? 0 : datum.value / compensationData.total
    })

    return array
}

export function summarize(array) {
    let fiscalYear = array[0]?.fiscalYear

    const summary = {
        salary: 0,
        bonus: 0,
        stocks: 0,
        options: 0,
        nonEquityIncentiveCompensation: 0,
        other: 0,
        total: 0,
        children: [],
    }

    array.forEach(c => {
        summary.children.push(c)

        summary.salary += c.salary ?? 0
        summary.bonus += c.bonus ?? 0
        summary.stocks += c.stocks ?? 0
        summary.options += c.options ?? 0
        summary.nonEquityIncentiveCompensation += c.nonEquityIncentiveCompensation ?? 0
        summary.other += c.other ?? 0
        summary.total += c.total ?? 0

        if (c.fiscalYear != fiscalYear) {
            fiscalYear = null
        }
    })

    if (fiscalYear !== null) {
        summary.fiscalYear = fiscalYear
    }

    summary.children.sort((lhs, rhs) => {
        let result = rhs.company.tracked - lhs.company.tracked

        if (result !== 0) {
            return result
        }

        return lhs.company.name.localeCompare(rhs.company.name)
    })

    summary.companies = distinctBy(
        summary.children.map(c => c.company),
        c => c.id
    )

    return summary
}

export async function getCompensation(executiveId) {
    let { compensation, companies, currency } = await request.get(`/api/compensation/executives/${executiveId}`)

    companies = toDictionary(companies, c => c.id)

    compensation.forEach(c => {
        c.company = companies[c.companyId]

        if (!c.total) {
            c.total =
                (c.salary ?? 0) +
                (c.bonus ?? 0) +
                (c.stocks ?? 0) +
                (c.options ?? 0) +
                (c.nonEquityIncentiveCompensation ?? 0) +
                (c.other ?? 0)
        }
    })

    return {
        compensation: compensation.sort((lhs, rhs) => {
            let result = rhs.fiscalYear - lhs.fiscalYear

            if (result != 0) {
                return result
            }

            if (lhs.company.tracked !== rhs.company.tracked) {
                return lhs.company.tracked ? 0 : 1
            }

            return lhs.company.name.localeCompare(rhs.company.name)
        }),
        currency,
    }
}
